module.exports = __webpack_public_path__ + "static/media/6.18a212f4.jpg";